/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { DOCUMENT } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, switchMap } from 'rxjs';

import { ENVIRONMENT } from '@environment';
import { isLocalhost } from '@usheru-hff/sdk/utils';
import { UsheruApi } from '@usheru-hff/shared/data-access-backend';
import { Country, News } from '@usheru-hff/shared/domain';
import { LanguageParamsService } from '@usheru-hff/shared/utils-translation';

import { CountrySelectionService } from '../country-selection';

@Injectable({
  providedIn: 'root'
})
export class NewsService {
  private readonly usheruApi = inject(UsheruApi);
  private readonly http = inject(HttpClient);
  private readonly env = inject(ENVIRONMENT);
  private readonly document = inject(DOCUMENT);
  private readonly headers = this.usheruApi.getStandardHeader();
  private readonly countrySelectionService = inject(CountrySelectionService);
  private readonly languageParamsService = inject(LanguageParamsService);

  private get attachLanguage(): LanguageParamsService['attachLanguage'] {
    return this.languageParamsService.attachLanguage.bind(this.languageParamsService);
  }

  getNews(pageNumber: number = 1, newsLimit: number, reqParams?: Record<string, unknown>): Observable<News[]> {
    return this.countrySelectionService.initialCountry$.pipe(
      switchMap(country => this.getNewsApi(pageNumber, newsLimit, country, reqParams))
    );
  }

  getNewsItem(id: number, trLanguage?: string): Observable<News> {
    if (this.isLocalEnv && this.placeholderData?.newsPosts) {
      const placeholder = typeof this.placeholderData.newsPosts === 'boolean' ? '1' : this.placeholderData.newsPosts;
      console.warn('Using placeholder data for news');
      return this.http.get<News>(`https://cdnstatic.usheru.com/assets/placeholder-data/newsPosts-${placeholder}.json`);
    }
    //
    let params = new HttpParams();
    if (trLanguage) params = params.set('trLanguage', trLanguage);

    return this.http.get<News>(`${this.env.api.url}/newsPosts/${id}`, {
      headers: this.headers,
      params: this.attachLanguage(params)
    });
  }
  _;

  private getNewsApi(
    pageNumber: number = 1,
    newsLimit: number,
    country?: Country,
    reqParams?: Record<string, unknown>
  ): Observable<News[]> {
    let params = new HttpParams({
      fromObject: {
        postLimit: newsLimit,
        page: pageNumber,
        ...(reqParams || {})
      }
    });

    if (country) params = params.set('country', country.id);
    return this.http.get<News[]>(this.env.api.newsPostsUrl(), {
      headers: this.headers,
      params: this.attachLanguage(params)
    });
  }
  get isLocalEnv() {
    return this.env.mode == 'develop' || this.env.mode == 'demo' || isLocalhost(this.document);
  }

  get placeholderData() {
    return this.env?.placeholderData;
  }
}
